import { getCookie } from '@vkontakte/vkjs';

export const oid = getCookie('oid') || '';
